import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { mntnAnalytics } from 'utilities/mntnAnalytics';

export const MntnTrackingPixel = () => {
  const location = useLocation();

  useEffect(() => {
    mntnAnalytics.fireTrackingPixel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return null;
};
